export default {
    title: 'Change organisation state',
    toggleText: 'Do you want to activate / deactivate the selected organisations?',
    activate: 'Activate',
    deactivate: 'Deactivate'
}